import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';
import { AccountDebitLottie } from 'Views/Page/Content/Templates/AccountDebitCommon/AccountDebitLottie';
import { AccountDebitTemplate } from 'Views/Page/Content/Templates/AccountDebitCommon/AccountDebitTemplate';


const Layout = () => {
  const {
    resource, errors,
  } = useMetaLayoutContext();

  return (
    <AccountDebitTemplate>
      <MetaControlField attr={'title'} />
      <br />
      <AccountDebitLottie resource={resource} />
      <MetaControlField attr={'header'} />
      <MetaControlField attr={'description'} />
      <ErrorList2 title={'Unable to set payment method to account debit'} errors={errors} />
    </AccountDebitTemplate>
  );
};

export default Layout;
